const translations = {
  common: {
    logo: "KOON-SERVICE",
    viewService: "ເບິ່ງບໍລິການ",
    explore: "ສຳຫຼວດບໍລິສັດ",
    contactHelp: "ຕິດຕໍ່ເຮົາເພື່ອຮັບການຊ່ວຍເຫຼືອ",
    contactButton: "ຕິດຕໍ່ພວກເຮົາ",
    footer: "© 2026 Koon-Service. All rights reserved. พัฒนาโดย นักศึกษาสาขาเทคโนโลยีดิจิทัลและสารสนเทศ ระดับปริญญาตรี",
    phone: "ໂທ : 062-428-3696",
    line: "Line : @koon_s",
    email: "E-mail : kvs_service@koonservice.com",
    hours: "ເວລາທຸກມື້ : 8:00 - 17:00",
  },
  nav: {
    home: "ໜ້າຫຼັກ",
    services: "ບໍລິການ",
    about: "ກ່ຽວກັບ",
    contact: "ຕິດຕໍ່",
  },
  language: {
    th: "TH 🇹🇭",
    en: "EN 🇺🇸",
    lo: "LA 🇱🇦",
    mm: "MM 🇲🇲",
  },
  hero: {
    subtitle: "ໂຊລູຊັນ IT ມືອາຊີບສໍາລັບທຸລະກິດຂອງທ່ານ",
    cta: "ສຳຫຼວດບໍລິສັດ",
  },
  home: {
    servicesTitle: "ບໍລິການຂອງພວກເຮົາ",
    whyTitle: "ເປັນເຫົາຫຼັກໃດທີ່ເລືອກເຮົາ",
    why: [
      {
        title: "ໄວ",
        desc: "ເຮົາໃຫ້ບໍລິການໄວເພື່ອລົດເວລາການຢຸດຊົ່ວໂມງແລະເຮັດໃຫ້ທຸລະກິດຂອງທ່ານດໍາເນີນງານໄດ້ຕໍ່ເນື່ອງ",
      },
      {
        title: "ມືອາຊີບ",
        desc: "ທີມງານຂອງເຮົາມີປະສົບການ IT ກວ່າ 5 ປີ ແລະແກ້ໄຂບັນຫາໄດ້ຢ່າງມີປະສິດທິພາບ",
      },
      {
        title: "ມາດຕະຖານສູງ",
        desc: "ເຮົານຳມາດຕະຖານສາກົນໃຊ້ໃນການໃຫ້ບໍລິການເພື່ອໃຫ້ລະບົບຂອງທ່ານມີຄວາມເສັ້ນສະຖິດ, ປອດໄພ, ແລະພ້ອມໃຊ້ງານ",
      },
    ],
    contactTitle: "ຂໍ້ມູນຕິດຕໍ່",
    address1: "Koon Service Co., Ltd.\n329 Moo 10 Main Road, Bang Sao Thong, Bang Sao Thong District, Samut Prakan 10570",
    address2: "Koon Service Co., Ltd.\n18 Soi Lasalle 65, Bang Na Tai, Bang Na, Bangkok 10260",
  },
  services: {
    itService: "ບໍລິການດ້ານໄອທີ,",
    cctv: "ຄວາມປອດໄພ",
    equipment: "ອຸ​ປະ​ກອນ​ໄອ​ທີ",
    network: "ເຄືອຂ່າຍ ແລະຄວາມປອດໄພ",
  },
  itService: {
    title: "IT Service",
    introTitle: "ບໍລິການ IT ສໍາລັບອົງກອນ",
    introText: "ເຮົາມີທີມງານ IT Outsource ທີ່ມີຄວາມຊ່ຽງຊານ ເພື່ອຕິດຕັ້ງ, ແກ້ໄຂ, ແລະດູແລລະບົບ IT ເພື່ອໃຫ້ອົງກອນຂອງທ່ານເຮັດວຽກໄດ້ຕໍ່ເນື່ອງ",
    detailTitle: "ຂອບເຂດການໃຫ້ບໍລິການ",
    pointsLeft: [
      "ຕິດຕັ້ງລະບົບຄອມພິວເຕີແລະ Network",
      "ກວດສອບແລະແກ້ໄຂບັນຫາ Hardware / Software",
      "ດູແລ Server ແລະລະບົບໃນອົງກອນ",
      "ສັນສອງ Support ຜູ້ໃຊ້ (Helpdesk)",
      "ຕັ້ງຄ່າລະບົບ WiFi / LAN",
    ],
    pointsRight: [
      "ບໍລິການບໍລິການລະບົບ IT",
      "ດູແລ Security / Firewall",
      "ສຳນັກຂໍ້ມູນ (Backup)",
      "ການເບິງແຫ່ງ 24/7",
      "ຄຳແນະນຳ IT",
    ],
    problemsTitle: "ຫາກທ່ານພົບບັນຫາເຫັນໄດ້ເຫັນຕໍ່ໄປນີ້",
    ctaContact: "ຕິດຕໍ່ເຮົາເພື່ອຮັບການຊ່ວຍເຫຼືອ",
  },
  cctv: {
    title: "CCTV & SECURITY",
    introTitle: "ບໍລິການຕິດຕັ້ງແລະດູແລ CCTV",
    introText: "ເຮົາອອກແບບ, ຕິດຕັ້ງ, ແລະດູແລລະບົບ CCTV ພ້ອມລະບົບຄວາມປອດໄພຄົບວົງຈອບ ສໍາລັບອົງກອນ, ສຳນັກງານ, ໂຮງງານ ແລະທຸລະກິດ",
    detailTitle: "ຂອບເຂດການໃຫ້ບໍລິການ",
    pointsLeft: [
      "ອອກແບບແລະຕິດຕັ້ງ CCTV ຕາມພື້ນທີ່",
      "ຕິດຕັ້ງ IP Camera ແລະ Analog Camera",
      "ວາງລະບົບສາຍແລະເຄື່ອງມື network",
      "ຕິດຕັ້ງ NVR / DVR",
      "ຕັ້ງຄ່າເບິ່ງຜ່ານໂທລະສັບແລະອິນເຕີເນັດ",
    ],
    pointsRight: [
      "ດູແລລະບໍລິການ CCTV",
      "ກວດສອບແລະແກ້ໄຂບັນຫາກ້ອງ",
      "ປັບປຸງແລະອັບເກຣດລະບົບ",
      "ໃຫ້ຄຳແນະນຳລະບົບຄວາມປອດໄພ",
      "ບໍລິການດູແລເດືອນ",
    ],
    problemsTitle: "ບັນຫາທີ່ທຸລະກິດມັກພົບກັບ CCTV",
    cards: [
      { title: "ພາບບໍ່ຫນາ", desc: "ພາບບໍ່ຄັມຊັດ ຫຼືບໍ່ເຫັນໃນການນັບຄືນ" },
      { title: "ການຕິດຕັ້ງບໍ່ຖືກ", desc: "ມຸ່ມກ້ອງບໍ່ຄຸບຄຸມພື້ນທີ່ສຳຄັນ" },
      { title: "ລະບົບບໍ່ສະຖິດ", desc: "ກ້ອງລໍຫຼັງບໍ່ສາມາດດູໄດ້" },
      { title: "ບໍ່ມີຜູ້ດູແລ", desc: "ບໍ່ມີທີມງານດູແລ່ງ" },
    ],
    ctaContact: "ຕິດຕໍ່ເຮົາເພື່ອຊ່ວຍແກ້ໄຂ",
  },
  equipment: {
    title: "IT Equipment",
    introTitle: "ຈຳໜາຍແລະຕິດຕັ້ງອຸປະກອນ IT",
    introText: "ເຮົາຈຳໜາຍແລະຕິດຕັ້ງອຸປະກອນ IT ສໍາລັບອົງກອນ ເຊັ່ນ ကွန်ပျူတာ, ဆာဗာ, ကွန်ယက်ပစ္စည်းများ, ແລະရုံးစနစ်များ",
    detailTitle: "ຂອບເຂດການໃຫ້ບໍລິການ",
    pointsLeft: [
      "ຈຳໜາຍ PC / Notebook",
      "ຈຳໜາຍ Router, Switch, Access Point",
      "ຈຳໜາຍ Server ແລະ NAS",
      "ອຸປະກອນຮ່ວມງານເຊັ່ນ Printer / Scanner",
      "ອຸປະກອນເສີມເຊັ່ນ UPS / Rack / ສາຍ",
    ],
    pointsRight: [
      "ຕິດຕັ້ງແລະຕັ້ງຄ່າອຸປະກອນ",
      "ອອກແບບ Network ສໍາລັບອົງກອນ",
      "ຕິດຕັ້ງ Server ແລະ Backup",
      "ແນະນຳອຸປະກອນທີ່ເໝາະສົມ",
      "ບໍລິການຫຼັງຂາຍແລະດູແລ",
    ],
    cards: [
      { title: "ອຸປະກອນເກົ່າ", desc: "စနစ်နှေးနှေး မပံ့ပိုးပစ္စည်း အသစ်" },
      { title: "ເລືອກຜິດ", desc: "စက်ပစ္စည်းမဟုတ်သော မူလလိုအပ်ချက်" },
      { title: "စနစ်မတည်ငြိမ်", desc: "ပစ္စည်းများ မကြာခဏ ပြဿနာ" },
      { title: "မရှိသူအကူ", desc: "IT အဖွဲ့မရှိဘဲ ပြဿနာဖြစ်" },
    ],
    ctaTitle: "အဖွဲ့အစည်းအတွက် IT ပစ္စည်း လိုပါသလား?",
    ctaText: "အလုပ်သင်တန်းကိုက်ညီသော စနစ် ရွေးချယ်ရန် ကျွမ်းကျင်သူနှင့် ပြောဆိုပါ",
  },
  network: {
    title: "NETWORK & SECURITY",
    introTitle: "ကွန်ယက်နှင့် လုံခြုံရေး စနစ် 설치",
    introText: "ကျွန်တော်တို့သည် အဖွဲ့အစည်းများအတွက် ကွန်ယက်နှင့် လုံခြုံရေး စနစ်များကို ဒီဇိုင်း၊ 설치 နှင့် ထိန်းသိမ်းပေးပါသည်။",
    detailTitle: "ဝန်ဆောင်မှု ကဏ္ဍများ",
    pointsLeft: [
      "LAN / WiFi ကွန်ယက် 설치",
      "Router, Switch, Access Point 설치",
      "Network ဖွဲ့စည်းမှု ဒီဇိုင်း",
      "VLAN 설치 နှင့် Traffic စီမံခြင်း",
      "အင်တာနက်နှင့် Cloud ချိတ်ဆက်ခြင်း",
    ],
    pointsRight: [
      "Firewall 설치 နှင့် ကာကွယ်မှု",
      "ဗိုင်းရပ်စ်နှင့် Malware ကာကွယ်မှု",
      "ဝေးနေကြာမှ VPN 설치",
      "ဒေတာ洩露 ကာကွယ်မှု",
      "Network တိုက်ရိုက် စောင့်ကြည့်မှု",
    ],
    problemsTitle: "Network များစွာ ပုံမှန်ပြဿနာများ",
    cards: [
      { title: "အင်တာနက်နှေး", desc: "ကွန်ယက်မတည်ငြိမ်၍ အလုပ်နှေး" },
      { title: "ပိတ်ခံရခြင်းများ", desc: "Network မတည်ငြိမ်ရန် စီးပွားရေးထိခိုက်" },
      { title: "လုံခြုံရေး ထိခိုက်မှု", desc: "Firewall တို့ မရှိခြင်း" },
      { title: "ဒေတာမလုံခြုံ", desc: "ဟက်ဖ်ခြင်း သို့မဟုတ် ဒေတာ洩露 ရန်" },
    ],
    ctaTitle: "လုံခြုံသော network စနစ်လိုပါသလား?",
    ctaText: "သင့်လုပ်ငန်းအတွက် သင့်တော်သော စနစ်ကို ဒီဇိုင်းရန် ကျွမ်းကျင္သူနှင့် ဆွေးနွေးပါ",
  },
};
export default translations;